import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../utils/api";

const MEMBERSHIP_PLANS = [
  { name: "Starter",          price: "$29.99/mo", classes: "3 classes/mo",       extra: "Additional classes $9.99 each" },
  { name: "Performance",      price: "$59.99/mo", classes: "6 classes/mo",       extra: "Additional classes $4.99 each" },
  { name: "Unlimited Elite",  price: "$79.99/mo", classes: "Unlimited classes",  extra: null },
];

const CLASS_SCHEDULE = [
  { day: "Mon",  times: ["6:00 AM", "10:00 AM", "4:30 PM", "5:45 PM", "7:00 PM"] },
  { day: "Tue",  times: ["10:00 AM", "4:30 PM", "5:45 PM", "7:00 PM"] },
  { day: "Wed",  times: ["6:00 AM", "10:00 AM", "4:30 PM", "5:45 PM"] },
  { day: "Thu",  times: ["10:00 AM", "4:30 PM", "5:45 PM", "7:00 PM"] },
  { day: "Fri",  times: ["6:00 AM", "10:00 AM", "4:30 PM", "5:45 PM"] },
  { day: "Sat",  times: ["10:00 AM", "11:15 AM", "12:30 PM Beginners"] },
  { day: "Sun",  times: ["10:00 AM", "11:15 AM"] },
];

// ── LEADERBOARD SECTION COMPONENT (Step 13) ──────────────────────────────────
function LeaderboardSection({ participantId }) {
  const [data, setData]   = useState(null);
  const [myStats, setMyStats] = useState(null);
  useEffect(() => {
    axios.get(`${API}/campaign/leaderboard`).then(r => setData(r.data)).catch(() => {});
    if (participantId) {
      axios.get(`${API}/campaign/participant/${participantId}`).then(r => setMyStats(r.data)).catch(() => {});
    }
  }, [participantId]);
  if (!data || !data.leaderboard_visible || data.leaderboard.length === 0) return null;
  const medals = { 1: "🥇", 2: "🥈", 3: "🥉" };
  const myRank = myStats?.current_rank;
  const inTop  = myRank && myRank <= data.leaderboard.length;
  return (
    <div style={{ marginTop: 32 }}>
      <div style={{ fontSize: 13, color: "#FFB612", fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", marginBottom: 12, textAlign: "center" }}>
        Live Leaderboard — Top {data.top_n || 10}
      </div>
      <div style={{ background: "#111", border: "1px solid rgba(255,182,18,0.15)", borderRadius: 12, overflow: "hidden" }}>
        {data.leaderboard.map((p, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", padding: "10px 14px", borderTop: i > 0 ? "1px solid rgba(255,255,255,0.05)" : "none", gap: 10 }}>
            <span style={{ fontSize: 14, width: 24, flexShrink: 0 }}>{medals[p.rank] || `#${p.rank}`}</span>
            <span style={{ flex: 1, fontSize: 14, fontWeight: 700, color: "#fff" }}>{p.display_name}</span>
            <span style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", marginRight: 8 }}>{p.verified_referrals} refs</span>
            <span style={{ fontSize: 13, fontWeight: 900, color: "#FFB612" }}>{p.total_points} pts</span>
            {p.prize_label && <span style={{ fontSize: 10, fontWeight: 800, color: "#FFB612", background: "rgba(255,182,18,0.15)", padding: "2px 6px", borderRadius: 4, marginLeft: 4 }}>{p.prize_label}</span>}
          </div>
        ))}
      </div>
      {/* Personal rank if outside top N */}
      {myStats && !inTop && myRank && (
        <div style={{ marginTop: 10, background: "rgba(255,182,18,0.08)", border: "1px solid rgba(255,182,18,0.2)", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "rgba(255,255,255,0.75)", textAlign: "center" }}>
          Your current position: <strong style={{ color: "#FFB612" }}>#{myRank}</strong> — {myStats.verified_referral_count} verified referral{myStats.verified_referral_count !== 1 ? "s" : ""} — {myStats.total_points} points
        </div>
      )}
    </div>
  );
}



function ShareDashboard({ participantId, firstName, isMember, initialResult, homeUrl, campaign }) {
  const [stats, setStats]           = useState(null);
  const [copied, setCopied]         = useState(false);
  const [showIGInstructions, setShowIGInstructions] = useState(false);
  const [actionFeedback, setActionFeedback] = useState("");

  const refLink = stats?.referral_link || initialResult?.referral_link || homeUrl;
  const caption = stats?.suggested_caption || "I'm trying to win 3 FREE months of unlimited boxing at Neighborhood Boxing Club. Tap my link and enter — it helps me climb the leaderboard.";

  useEffect(() => {
    if (!participantId) return;
    axios.get(`${API}/campaign/participant/${participantId}`)
      .then(r => setStats(r.data))
      .catch(() => {});
  }, [participantId]);

  const trackAction = async (actionType) => {
    try {
      const res = await axios.post(`${API}/campaign/social-action`, { participant_id: participantId, action_type: actionType });
      if (res.data.points_awarded > 0) setActionFeedback(`+${res.data.points_awarded} point${res.data.points_awarded !== 1 ? "s" : ""}!`);
      else if (res.data.requires_review) setActionFeedback("Submitted for review!");
      setTimeout(() => setActionFeedback(""), 3000);
    } catch { /* silent */ }
  };

  const copyLink = () => {
    navigator.clipboard?.writeText(refLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
    trackAction("copy_link_click");
  };

  const rank = stats?.current_rank;
  const prizeMedals = { 1: "🥇", 2: "🥈", 3: "🥉" };

  const btnP  = { display: "block", background: "#FFB612", color: "#000", border: "none", borderRadius: 10, padding: "13px 18px", fontSize: 15, fontWeight: 900, cursor: "pointer", width: "100%", textDecoration: "none", textAlign: "center", marginBottom: 10 };
  const btnS  = { display: "block", background: "#111", color: "#FFB612", border: "2px solid #FFB612", borderRadius: 10, padding: "12px 18px", fontSize: 14, fontWeight: 800, cursor: "pointer", width: "100%", textDecoration: "none", textAlign: "center", marginBottom: 10 };
  const btnG  = { display: "block", background: "#111", color: "rgba(255,255,255,0.65)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 10, padding: "11px 18px", fontSize: 13, fontWeight: 700, cursor: "pointer", width: "100%", textDecoration: "none", textAlign: "center", marginBottom: 10 };

  return (
    <div style={{ background: "#0A0A0A", minHeight: "100vh", color: "#fff", fontFamily: "Inter, sans-serif" }}>
      <div style={{ maxWidth: 480, margin: "0 auto", padding: "32px 20px 60px" }}>

        <div style={{ textAlign: "center", marginBottom: 18 }}>
          <img src="/nbc_logo.jpg" alt="NBC Boxing" style={{ width: 64, height: 64, objectFit: "contain", borderRadius: 8 }} />
        </div>

        {/* Entry confirmed */}
        <div style={{ background: "#FFB612", borderRadius: 12, padding: "16px 20px", marginBottom: 20, textAlign: "center" }}>
          <div style={{ fontSize: 20, fontWeight: 900, color: "#000" }}>🥊 You&apos;re officially entered.</div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#000", marginTop: 5 }}>Now choose your next move, {firstName}.</div>
        </div>

        {/* Campaign expiration date — shown when end_date is configured */}
        {campaign?.end_date && (
          <div style={{ background: "rgba(255,182,18,0.08)", border: "1px solid rgba(255,182,18,0.2)", borderRadius: 10, padding: "10px 16px", marginBottom: 16, textAlign: "center", fontSize: 13, color: "rgba(255,255,255,0.75)" }}>
            ⏳ Contest ends:{" "}
            <strong style={{ color: "#FFB612" }}>
              {(() => {
                try {
                  const dateStr = new Date(`${campaign.end_date}T12:00:00`).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
                  if (!campaign.end_time) return dateStr;
                  const [h, m] = campaign.end_time.split(":").map(Number);
                  const ampm = h >= 12 ? "PM" : "AM";
                  const h12 = h % 12 || 12;
                  return `${dateStr} at ${h12}:${String(m).padStart(2, "0")} ${ampm} ET`;
                } catch { return campaign.end_date; }
              })()}
            </strong>
          </div>
        )}

        {/* Live stats */}
        {stats && (
          <div style={{ background: "#111", border: "1px solid rgba(255,182,18,0.2)", borderRadius: 12, padding: "14px 16px", marginBottom: 20, display: "flex", justifyContent: "space-around", textAlign: "center" }}>
            <div>
              <div style={{ fontSize: 22, fontWeight: 900, color: "#FFB612" }}>{stats.verified_referral_count}</div>
              <div style={{ fontSize: 11, color: "rgba(255,255,255,0.5)", marginTop: 2 }}>Referrals</div>
            </div>
            <div>
              <div style={{ fontSize: 22, fontWeight: 900, color: "#FFB612" }}>{stats.total_points}</div>
              <div style={{ fontSize: 11, color: "rgba(255,255,255,0.5)", marginTop: 2 }}>Points</div>
            </div>
            <div>
              <div style={{ fontSize: 22, fontWeight: 900, color: rank && rank <= 3 ? "#FFB612" : "#fff" }}>
                {rank ? `#${rank}` : "–"}
              </div>
              <div style={{ fontSize: 11, color: "rgba(255,255,255,0.5)", marginTop: 2 }}>Rank</div>
            </div>
          </div>
        )}

        {/* Prize position if Top 3 */}
        {rank && rank <= 3 && stats?.prize_position && (
          <div style={{ background: "rgba(255,182,18,0.12)", border: "1px solid #FFB612", borderRadius: 10, padding: "12px 16px", marginBottom: 20, textAlign: "center" }}>
            <div style={{ fontSize: 20 }}>{prizeMedals[rank] || "🏆"}</div>
            <div style={{ fontSize: 14, fontWeight: 900, color: "#FFB612", marginTop: 4 }}>
              You&apos;re currently in {rank === 1 ? "1st" : rank === 2 ? "2nd" : "3rd"} place!
            </div>
            <div style={{ fontSize: 13, color: "#fff", marginTop: 4 }}>{stats.prize_position.description}</div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", marginTop: 4 }}>Keep sharing to hold your position.</div>
          </div>
        )}

        {/* Member / guest message */}
        {isMember ? (
          <div style={{ background: "rgba(255,182,18,0.07)", border: "1px solid rgba(255,182,18,0.18)", borderRadius: 10, padding: "12px 16px", marginBottom: 18, fontSize: 13, color: "rgba(255,255,255,0.75)", lineHeight: 1.7 }}>
            Current members can win too. If you finish in the Top 3, Neighborhood Boxing Club will handle your prize manually/reimburse you directly.
          </div>
        ) : (
          <>
            <div style={{ background: "rgba(255,182,18,0.07)", border: "1px solid rgba(255,182,18,0.18)", borderRadius: 10, padding: "12px 16px", marginBottom: 16, fontSize: 13, color: "rgba(255,255,255,0.75)", lineHeight: 1.9 }}>
              🥊 Don&apos;t wait for the contest to end — start boxing NOW! 🔥<br />
              If you finish in the Top 3, Neighborhood Boxing Club will reimburse your winning prize manually. 💰🏆<br />
              Start training today, keep sharing your link, and climb that leaderboard! 🚀
            </div>
            <div style={{ marginBottom: 6 }}>
              <div style={{ fontSize: 12, color: "#FFB612", fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", marginBottom: 14, textAlign: "center" }}>Choose Your Intro Offer</div>

              {/* Card 1 — Free 1 Week Elite Unlimited Pass — MOST POPULAR */}
              <div style={{ background: "#111", border: "2px solid #FFB612", borderRadius: 14, padding: "18px 16px", marginBottom: 12 }}>
                <div style={{ marginBottom: 8 }}>
                  <span style={{ background: "#FFB612", color: "#000", fontSize: 10, fontWeight: 900, letterSpacing: 1.5, padding: "3px 10px", borderRadius: 20, textTransform: "uppercase" }}>Most Popular</span>
                </div>
                <div style={{ fontSize: 16, fontWeight: 900, color: "#FFB612", marginBottom: 8 }}>Free 1 Week Elite Unlimited Pass</div>
                <div style={{ fontSize: 13, color: "rgba(255,255,255,0.7)", lineHeight: 1.6, marginBottom: 14 }}>
                  Best for trying unlimited classes for a full week and getting the full Neighborhood Boxing Club experience.
                </div>
                <a href={homeUrl} style={{ ...btnP, marginBottom: 0 }}>Claim My Free 1 Week Elite Unlimited Pass</a>
              </div>

              {/* Card 2 — First Class Free */}
              <div style={{ background: "#111", border: "1px solid #FFB612", borderRadius: 14, padding: "18px 16px", marginBottom: 12 }}>
                <div style={{ fontSize: 16, fontWeight: 900, color: "#FFB612", marginBottom: 8 }}>First Class Free</div>
                <div style={{ fontSize: 13, color: "rgba(255,255,255,0.7)", lineHeight: 1.6, marginBottom: 14 }}>
                  Perfect if you want to try one class first before committing to anything.
                </div>
                <a href={homeUrl} style={{ ...btnP, marginBottom: 0 }}>Claim My First Class Free</a>
              </div>

              {/* Card 3 — $1 First Month */}
              <div style={{ background: "#111", border: "1px solid #FFB612", borderRadius: 14, padding: "18px 16px", marginBottom: 4 }}>
                <div style={{ fontSize: 16, fontWeight: 900, color: "#FFB612", marginBottom: 8 }}>$1 First Month</div>
                <div style={{ fontSize: 13, color: "rgba(255,255,255,0.7)", lineHeight: 1.6, marginBottom: 14 }}>
                  Best value if you already know you&apos;re ready to start training now.
                </div>
                <a href={homeUrl} style={{ ...btnP, marginBottom: 0 }}>Start My $1 First Month</a>
              </div>
            </div>
          </>
        )}

        {/* Book a Class — separate section, extra spacing above */}
        <div style={{ marginTop: 28, marginBottom: 16 }}>
          <div style={{ fontSize: 12, color: "rgba(255,255,255,0.45)", fontWeight: 700, letterSpacing: 1, textTransform: "uppercase", marginBottom: 12, textAlign: "center" }}>Already Have a Pass or Membership?</div>
          <div style={{ background: "#111", border: "1px solid rgba(255,182,18,0.4)", borderRadius: 14, padding: "18px 16px" }}>
            <div style={{ fontSize: 15, fontWeight: 900, color: "#fff", marginBottom: 6 }}>Book a Class</div>
            <div style={{ fontSize: 13, color: "rgba(255,255,255,0.6)", lineHeight: 1.6, marginBottom: 14 }}>
              View the schedule and reserve your spot for your next boxing class.
            </div>
            <a href="https://neighborhoodboxingclub.us/dashboard/classes" style={{ ...btnS, marginBottom: 0 }}>
              View Schedule &amp; Book a Class
            </a>
          </div>
        </div>

        {/* START REFERRING — main section */}
        <div style={{ background: "#111", border: "1px solid #FFB612", borderRadius: 12, padding: 18, marginBottom: 16 }}>
          <div style={{ fontSize: 16, fontWeight: 900, color: "#FFB612", marginBottom: 8, textAlign: "center" }}>Start Referring to Win</div>
          <div style={{ fontSize: 13, color: "rgba(255,255,255,0.7)", lineHeight: 1.7, marginBottom: 14 }}>
            This is how you compete for the grand prize. Share your personal link on Facebook, Instagram, text, or Messenger. Every verified person who enters through your link gives you points. Top 3 on the leaderboard win free unlimited boxing.
          </div>

          {/* Referral link */}
          <div style={{ background: "#1A1A1A", borderRadius: 8, padding: "9px 12px", fontSize: 12, color: "rgba(255,255,255,0.6)", wordBreak: "break-all", marginBottom: 10 }}>
            {refLink}
          </div>

          {/* Action feedback flash */}
          {actionFeedback && (
            <div style={{ background: "rgba(255,182,18,0.15)", borderRadius: 8, padding: "8px 12px", fontSize: 13, fontWeight: 800, color: "#FFB612", textAlign: "center", marginBottom: 10 }}>
              {actionFeedback}
            </div>
          )}

          {/* Share buttons */}
          <button onClick={copyLink} style={btnP}>{copied ? "✓ Copied!" : "Copy My Referral Link"}</button>

          <a
            href={`sms:?body=${encodeURIComponent(`${caption} ${refLink}`)}`}
            style={btnS}
            onClick={() => trackAction("text_share_click")}
          >📱 Share by Text</a>

          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(refLink)}`}
            target="_blank" rel="noopener noreferrer"
            style={{ ...btnS, borderColor: "#1877F2", color: "#1877F2" }}
            onClick={() => trackAction("facebook_share_click")}
          >Facebook Share</a>

          <a
            href={`fb-messenger://share?link=${encodeURIComponent(refLink)}`}
            style={{ ...btnG }}
            onClick={() => trackAction("messenger_share_click")}
          >Share on Messenger</a>

          <button onClick={() => setShowIGInstructions(v => !v)} style={{ ...btnG, cursor: "pointer", background: "none", border: "1px solid rgba(255,255,255,0.15)", color: "rgba(255,255,255,0.65)", marginBottom: showIGInstructions ? 0 : 10 }}>
            Instagram Sharing Instructions {showIGInstructions ? "▲" : "▼"}
          </button>
          {showIGInstructions && (
            <div style={{ background: "#1A1A1A", borderRadius: 8, padding: "12px 14px", fontSize: 13, color: "rgba(255,255,255,0.7)", lineHeight: 1.8, marginBottom: 10 }}>
              1. Copy your referral link above.<br />
              2. Open Instagram → tap your profile → Edit Profile → Website.<br />
              3. Paste your link and save.<br />
              4. Create a Story or post and tell your followers: tap the link in your bio to enter and help you win 3 free months of boxing!<br />
              5. Tag @nboxingc if possible.
            </div>
          )}

          {/* Suggested caption */}
          <div style={{ marginTop: 8, marginBottom: 10 }}>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", marginBottom: 6, textTransform: "uppercase", letterSpacing: 1 }}>Suggested Caption</div>
            <div style={{ background: "#1A1A1A", borderRadius: 8, padding: "10px 12px", fontSize: 13, color: "rgba(255,255,255,0.7)", lineHeight: 1.6, marginBottom: 8 }}>
              &ldquo;{caption}&rdquo;
            </div>
            <button
              onClick={() => { navigator.clipboard?.writeText(caption); setActionFeedback("Caption copied!"); setTimeout(() => setActionFeedback(""), 2500); }}
              style={{ ...btnG, marginBottom: 0 }}
            >Copy Caption</button>
          </div>
        </div>

        {/* Social claim section */}
        <div style={{ background: "#111", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 12, padding: 16, marginBottom: 16 }}>
          <div style={{ fontSize: 12, color: "#FFB612", fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", marginBottom: 12 }}>Claim Bonus Points</div>
          {[
            { label: "I followed NBC on Instagram",    action: "instagram_follow_claim" },
            { label: "I liked/followed NBC on Facebook", action: "facebook_follow_claim" },
          ].map(({ label, action }) => (
            <button key={action} onClick={() => trackAction(action)} style={{ ...btnG, marginBottom: 8, textAlign: "left", padding: "10px 14px" }}>
              {label} <span style={{ float: "right", color: "#FFB612", fontSize: 12 }}>Claim →</span>
            </button>
          ))}
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginTop: 6, lineHeight: 1.5 }}>
            Social follows and likes are submitted for admin review. Bonus points are awarded after verification.
          </div>
        </div>

        {/* Leaderboard (Step 13) */}
        <LeaderboardSection participantId={participantId} />

      </div>
    </div>
  );
}


export default function CampaignPage() {
  const [campaign, setCampaign]     = useState(null);
  const [isQR, setIsQR]             = useState(false);
  const [referredByCode, setReferredByCode] = useState("");
  const [source, setSource]         = useState("direct");

  const [form, setForm] = useState({
    first_name: "", last_name: "", phone: "", status: "guest"
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError]           = useState("");
  const [result, setResult]         = useState(null);
  const [showPopup, setShowPopup]   = useState(false);

  // Step 6 — verification state
  const [verifyStage, setVerifyStage]   = useState(false); // true = show code input
  const [verifyCode, setVerifyCode]     = useState("");
  const [verifying, setVerifying]       = useState(false);
  const [verifyError, setVerifyError]   = useState("");
  const [resendSeconds, setResendSeconds] = useState(60);
  const [participantId, setParticipantId] = useState("");
  const [maskedPhone, setMaskedPhone]   = useState("");

  // ── Parse URL params on mount + restore saved dashboard session
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const src = (params.get("src") || "").toLowerCase();
    const ref = params.get("ref") || "";
    const pid = params.get("pid") || "";
    setIsQR(src === "qr" || params.get("qr") === "1");
    setSource(src || "direct");
    if (ref) setReferredByCode(ref);
    // Restore saved session: ?pid= URL param (tapped from SMS) or localStorage (same device)
    const savedPid = pid || localStorage.getItem("nbc_campaign_pid") || "";
    if (savedPid) {
      axios.get(`${API}/campaign/participant/${savedPid}`)
        .then(r => {
          setParticipantId(savedPid);
          setResult({ confirmed_member: r.data.confirmed_member, referral_link: r.data.referral_link });
          setForm(f => ({ ...f, first_name: r.data.first_name || "" }));
          localStorage.setItem("nbc_campaign_pid", savedPid);
        })
        .catch(() => {
          // Invalid or expired participant — clear saved session silently
          localStorage.removeItem("nbc_campaign_pid");
        });
    }
  }, []);

  // ── Load campaign config
  useEffect(() => {
    axios.get(`${API}/campaign/active`)
      .then(r => setCampaign(r.data))
      .catch(() => setCampaign({
        headline_click: "Click to Win 3 FREE Months of Unlimited Boxing",
        headline_qr:    "Scan to Win 3 FREE Months of Unlimited Boxing",
        subheadline:    "Top 3 on the leaderboard win free unlimited boxing. Share your link. Get referrals. Climb the board.",
        prize_value:    "$240",
        clarity_line:   "No obligation. No credit card required to enter.",
        prizes: [
          { place: 1, label: "1st Place", description: "3 Months FREE Unlimited Elite Boxing", value: 240 },
          { place: 2, label: "2nd Place", description: "2 Months FREE Unlimited Elite Boxing", value: 160 },
          { place: 3, label: "3rd Place", description: "1 Month FREE Unlimited Elite Boxing",  value: 80  },
        ],
        contest_rules: [],
      }));
  }, []);

  // ── Popup show logic: 1.5s delay, suppressed if already entered or closed this session
  useEffect(() => {
    const alreadyEntered    = !!localStorage.getItem("nbc_campaign_pid");
    const closedThisSession = !!sessionStorage.getItem("nbc_popup_closed");
    const campaignActive    = campaign && !["closed", "expired"].includes(campaign.status);
    if (!campaignActive || alreadyEntered || closedThisSession || result) return;
    const timer = setTimeout(() => { if (!result) setShowPopup(true); }, 1500);
    return () => clearTimeout(timer);
  }, [campaign]); // eslint-disable-line react-hooks/exhaustive-deps

  // Hide popup the moment the form is successfully submitted
  useEffect(() => { if (result) setShowPopup(false); }, [result]);

  const closePopup = () => {
    sessionStorage.setItem("nbc_popup_closed", "1");
    setShowPopup(false);
  };

  const headline = campaign
    ? (isQR ? campaign.headline_qr : campaign.headline_click)
    : (isQR ? "Scan to Win 3 FREE Months of Unlimited Boxing"
             : "Click to Win 3 FREE Months of Unlimited Boxing");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.first_name || !form.last_name || !form.phone) {
      setError("Please fill in all fields.");
      return;
    }
    setError("");
    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/campaign/enter`, {
        ...form,
        source,
        referred_by: referredByCode,
      });
      if (res.data.already_entered && res.data.phone_verified) {
        setResult(res.data);
      } else if (res.data.already_entered) {
        // Already entered but not verified — drop into verify flow
        setParticipantId(res.data.participant_id);
        const digits = form.phone.replace(/\D/g, "");
        setMaskedPhone(`(${digits.slice(-10,-7)}) ***-${digits.slice(-4)}`);
        setVerifyStage(true);
        setResendSeconds(60);
      } else {
        setParticipantId(res.data.participant_id);
        const digits = form.phone.replace(/\D/g, "");
        setMaskedPhone(`(${digits.slice(-10,-7)}) ***-${digits.slice(-4)}`);
        setVerifyStage(true);
        setResendSeconds(60);
      }
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  // Countdown timer for resend button
  useEffect(() => {
    if (!verifyStage || resendSeconds <= 0) return;
    const t = setTimeout(() => setResendSeconds(s => s - 1), 1000);
    return () => clearTimeout(t);
  }, [verifyStage, resendSeconds]);

  const handleVerify = async (e) => {
    e.preventDefault();
    if (verifyCode.length !== 6) { setVerifyError("Enter the 6-digit code."); return; }
    setVerifyError(""); setVerifying(true);
    try {
      const res = await axios.post(`${API}/campaign/verify`, {
        participant_id: participantId, code: verifyCode,
      });
      setVerifyStage(false);
      setResult(res.data);
      // Save to localStorage so user can return to dashboard on same device
      localStorage.setItem("nbc_campaign_pid", participantId);
    } catch (err) {
      setVerifyError(err.response?.data?.detail || "Incorrect code. Please try again.");
    } finally { setVerifying(false); }
  };

  const handleResend = async () => {
    if (resendSeconds > 0) return;
    try {
      await axios.post(`${API}/campaign/resend-code`, { participant_id: participantId });
      setVerifyCode(""); setVerifyError(""); setResendSeconds(60);
    } catch (err) {
      setVerifyError(err.response?.data?.detail || "Could not resend. Please try again.");
    }
  };

  // ── VERIFICATION SCREEN (Step 6)
  if (verifyStage) {
    return (
      <div style={{ background: "#0A0A0A", minHeight: "100vh", color: "#fff", fontFamily: "Inter, sans-serif" }}>
        <div style={{ maxWidth: 440, margin: "0 auto", padding: "60px 20px", textAlign: "center" }}>
          <img src="/nbc_logo.jpg" alt="NBC Boxing" style={{ width: 72, height: 72, objectFit: "contain", borderRadius: 8, marginBottom: 28 }} />
          <div style={{ fontSize: 24, fontWeight: 900, color: "#FFB612", marginBottom: 12 }}>Verify Your Phone</div>
          <div style={{ fontSize: 15, color: "rgba(255,255,255,0.7)", marginBottom: 28, lineHeight: 1.6 }}>
            We sent a 6-digit code to<br />
            <strong style={{ color: "#fff" }}>{maskedPhone}</strong>
          </div>
          <form onSubmit={handleVerify}>
            <input
              type="text" inputMode="numeric" pattern="[0-9]*" maxLength={6}
              placeholder="6-digit code" value={verifyCode}
              onChange={e => setVerifyCode(e.target.value.replace(/\D/g, "").slice(0,6))}
              style={{ ...inputStyle, textAlign: "center", fontSize: 28, fontWeight: 900, letterSpacing: 12, marginBottom: 16 }}
            />
            {verifyError && (
              <div style={{ background: "rgba(255,0,0,0.15)", border: "1px solid rgba(255,0,0,0.4)", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "#ff6b6b", marginBottom: 12 }}>
                {verifyError}
              </div>
            )}
            <button
              type="submit" disabled={verifying || verifyCode.length !== 6}
              style={{ width: "100%", background: verifying || verifyCode.length !== 6 ? "rgba(255,182,18,0.4)" : "#FFB612", color: "#000", border: "none", borderRadius: 10, padding: "15px 20px", fontSize: 17, fontWeight: 900, cursor: verifying ? "default" : "pointer" }}
            >
              {verifying ? "Verifying…" : "Confirm Code →"}
            </button>
          </form>
          <div style={{ marginTop: 20 }}>
            <button
              onClick={handleResend} disabled={resendSeconds > 0}
              style={{ background: "none", border: "none", color: resendSeconds > 0 ? "rgba(255,255,255,0.3)" : "#FFB612", fontSize: 14, fontWeight: 700, cursor: resendSeconds > 0 ? "default" : "pointer" }}
            >
              {resendSeconds > 0 ? `Resend code in ${resendSeconds}s` : "Resend Code"}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ── POST-ENTRY PARTICIPANT DASHBOARD (Steps 7, 8, 11, 12)
  if (result) {
    const isMember  = result.confirmed_member || form.status === "member";
    const HOME_URL  = result.homepage_url || campaign?.homepage_url || "https://neighborhoodboxingclub.us";

    return (
      <ShareDashboard
        participantId={participantId || result.participant_id}
        firstName={form.first_name}
        isMember={isMember}
        initialResult={result}
        homeUrl={HOME_URL}
        campaign={campaign}
      />
    );
  }

  // ── MAIN LANDING PAGE
  return (
    <div style={{ background: "#0A0A0A", minHeight: "100vh", color: "#fff", fontFamily: "Inter, sans-serif" }}>
      <style>{`
        @keyframes nbc-pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50%       { transform: scale(1.04); opacity: 0.82; }
        }
        @keyframes nbc-btn-alt {
          0%, 30%, 100% { opacity: 1; }
          15%           { opacity: 0.38; }
        }
        .nbc-input::placeholder { color: rgba(255,255,255,0.85); font-weight: 500; }
      `}</style>
      <div style={{ maxWidth: 480, margin: "0 auto", padding: "32px 20px 60px" }}>

        {/* ── VIDEO HERO — YouTube background with dimmed overlay ── */}
        <div style={{ position: "relative", marginLeft: -20, marginRight: -20, marginTop: -32, marginBottom: 28, overflow: "hidden", minHeight: 380 }}>

          {/* YouTube iframe — autoplay, muted, loop, no controls, no interaction */}
          <iframe
            src="https://www.youtube.com/embed/Et-bcYVyZ40?autoplay=1&mute=1&loop=1&playlist=Et-bcYVyZ40&controls=0&disablekb=1&playsinline=1&rel=0&showinfo=0&modestbranding=1"
            title="NBC Boxing"
            allow="autoplay; encrypted-media"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: 900,
              height: 506,
              transform: "translate(-50%, -50%)",
              border: "none",
              pointerEvents: "none",
              zIndex: 0
            }}
          />

          {/* Dark overlay — slightly brightened so boxing footage pops through */}
          <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.38)", zIndex: 1 }} />

          {/* Hero content — logo + all headline text on top of video */}
          <div style={{ position: "relative", zIndex: 2, textAlign: "center", padding: "44px 20px 40px" }}>
            <div style={{ marginBottom: 16 }}>
              <img src="/nbc_logo.jpg" alt="NBC Boxing" style={{ width: 72, height: 72, objectFit: "contain", borderRadius: 8 }} />
            </div>
            {/* Primary branded offer headline — two lines, sharp pulse */}
            <h1 style={{ fontWeight: 900, color: "#FFB612", lineHeight: 1.2, margin: "0 0 10px", animation: "nbc-pulse 2s ease-in-out infinite" }}>
              <span style={{ display: "block", fontSize: "clamp(38px, 10vw, 52px)", letterSpacing: -0.5 }}>FREE 1 WEEK</span>
              <span style={{ display: "block", fontSize: "clamp(22px, 6vw, 30px)", letterSpacing: 0.5 }}>ELITE UNLIMITED PASS</span>
            </h1>
            {/* No-commitment copy */}
            <p style={{ fontSize: 15, color: "rgba(255,255,255,0.95)", lineHeight: 1.6, margin: "0 0 10px", fontWeight: 600 }}>
              Get unlimited boxing classes for a full week. No commitment, no credit card required.
            </p>
            {/* Contest bonus line — visually emphasize 3 FREE months and $240 value */}
            <p style={{ fontSize: 14, color: "rgba(255,255,255,0.85)", lineHeight: 1.6, margin: "0 0 10px" }}>
              Plus, you&apos;ll be entered to win{" "}
              <strong style={{ color: "#FFB612", fontWeight: 900 }}>3 FREE months</strong>
              {" "}of Unlimited Elite Boxing —{" "}
              <strong style={{ color: "#FFB612", fontWeight: 900 }}>a $240 value</strong>.
            </p>
            {/* Referral/leaderboard line — smaller, bonus-detail feel */}
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.55)", fontStyle: "italic" }}>
              Share your personal link, get referrals, and climb the leaderboard. Top 3 win free unlimited boxing.
            </div>
          </div>
        </div>

        {/* ── LEAD FORM — free week is the primary ask ── */}
        <form onSubmit={handleSubmit} style={{ marginBottom: 32 }}>
          <div style={{ fontSize: 16, fontWeight: 800, color: "#FFB612", marginBottom: 14, textAlign: "center" }}>
            Claim Your FREE 1 Week Elite Unlimited Pass
          </div>

          {/* First Name, Last Name, Phone — visible immediately, no status gate */}
          <input
            className="nbc-input"
            type="text" placeholder="First Name" value={form.first_name}
            onChange={e => setForm(f => ({ ...f, first_name: e.target.value }))}
            style={inputStyle}
          />
          <input
            className="nbc-input"
            type="text" placeholder="Last Name" value={form.last_name}
            onChange={e => setForm(f => ({ ...f, last_name: e.target.value }))}
            style={inputStyle}
          />
          <input
            className="nbc-input"
            type="tel" placeholder="Phone Number" value={form.phone}
            onChange={e => setForm(f => ({ ...f, phone: e.target.value }))}
            style={inputStyle}
          />

          {error && (
            <div style={{ background: "rgba(255,0,0,0.15)", border: "1px solid rgba(255,0,0,0.4)", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "#ff6b6b", marginBottom: 12 }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            style={{ width: "100%", background: submitting ? "rgba(255,182,18,0.6)" : "#FFB612", color: "#000", border: "none", borderRadius: 10, padding: "15px 20px", fontSize: 17, fontWeight: 900, cursor: submitting ? "default" : "pointer", letterSpacing: 0.3 }}
          >
            {submitting ? "Entering…" : "Claim My FREE 1 Week Pass + Enter to Win"}
          </button>

          <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", textAlign: "center", marginTop: 10 }}>
            By entering, you agree to receive SMS updates about your free pass, referral link, and contest status.
          </div>
        </form>

        {/* ── PRIZE TIERS (moved below lead form) ── */}
        {(campaign?.prizes || [
          { place: 1, label: "1st Place", description: "3 Months FREE Unlimited Elite Boxing", value: 240 },
          { place: 2, label: "2nd Place", description: "2 Months FREE Unlimited Elite Boxing", value: 160 },
          { place: 3, label: "3rd Place", description: "1 Month FREE Unlimited Elite Boxing",  value: 80  },
        ]).map((prize) => {
          const medals = ["🥇", "🥈", "🥉"];
          const borderColors = ["#FFB612", "#C0C0C0", "#CD7F32"];
          const idx = prize.place - 1;
          return (
            <div key={prize.place} style={{ background: "#111", border: `1px solid ${borderColors[idx]}`, borderRadius: 12, padding: "14px 18px", marginBottom: 10, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span style={{ fontSize: 24 }}>{medals[idx]}</span>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 800, color: borderColors[idx], textTransform: "uppercase", letterSpacing: 1 }}>{prize.label}</div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: "#fff", marginTop: 2 }}>{prize.description}</div>
                </div>
              </div>
              <div style={{ fontSize: 18, fontWeight: 900, color: borderColors[idx], flexShrink: 0 }}>${prize.value}</div>
            </div>
          );
        })}

        {/* Contest rules note */}
        <div style={{ fontSize: 12, color: "rgba(255,255,255,0.35)", textAlign: "center", marginBottom: 28, lineHeight: 1.6 }}>
          Winners = Top 3 verified referrals on the final leaderboard after admin review.
          No fake, duplicate, or self-referrals counted.
        </div>

        {/* ── WHAT IS NBC ── */}
        <div style={{ background: "#111", border: "1px solid rgba(255,182,18,0.2)", borderRadius: 12, padding: 20, marginBottom: 20 }}>
          <div style={{ fontSize: 13, color: "#FFB612", fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", marginBottom: 10 }}>
            What Is Neighborhood Boxing Club?
          </div>
          <p style={{ fontSize: 14, color: "rgba(255,255,255,0.85)", lineHeight: 1.7, margin: "0 0 16px" }}>
            Neighborhood Boxing Club is boxing for fitness — no fighting, no ring, and no experience needed.
            We offer high-energy boxing workouts, real boxing training, and a welcoming community for all fitness levels.
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {[
              "Boxing for fitness",
              "Beginner friendly",
              "No experience needed",
              "No fighting",
              "High-energy workouts",
              "Welcoming community",
              "Located in Columbus, Ohio",
            ].map(tag => (
              <span key={tag} style={{ background: "rgba(255,182,18,0.12)", color: "#FFB612", fontSize: 12, fontWeight: 700, padding: "5px 12px", borderRadius: 20, border: "1px solid rgba(255,182,18,0.25)" }}>
                {tag}
              </span>
            ))}
          </div>
        </div>

        {/* ── MEMBERSHIP PRICING (Step 9 — compact rows) ── */}
        <div style={{ marginBottom: 28 }}>
          <div style={{ fontSize: 13, color: "#FFB612", fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", marginBottom: 12, textAlign: "center" }}>
            Membership Plans
          </div>
          <div style={{ background: "#111", border: "1px solid rgba(255,182,18,0.15)", borderRadius: 12, overflow: "hidden" }}>
            {MEMBERSHIP_PLANS.map((plan, i) => (
              <div key={plan.name} style={{ padding: "12px 16px", borderTop: i > 0 ? "1px solid rgba(255,255,255,0.06)" : "none", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 10 }}>
                <div style={{ flex: 1 }}>
                  <span style={{ fontSize: 14, fontWeight: 800, color: "#fff" }}>{plan.name}</span>
                  <span style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", marginLeft: 8 }}>{plan.classes}</span>
                  {plan.extra && (
                    <div style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", marginTop: 2 }}>{plan.extra}</div>
                  )}
                </div>
                <div style={{ fontSize: 15, fontWeight: 900, color: "#FFB612", flexShrink: 0 }}>{plan.price}</div>
              </div>
            ))}
          </div>
          <div style={{ fontSize: 12, color: "rgba(255,255,255,0.3)", textAlign: "center", marginTop: 10, fontStyle: "italic" }}>
            Contest prize is based on the Unlimited Elite plan — up to a $240 value.
          </div>
        </div>

        {/* ── CLASS SCHEDULE (Step 10 — compact with format explanation) ── */}
        <div>
          <div style={{ fontSize: 13, color: "#FFB612", fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", marginBottom: 10, textAlign: "center" }}>
            Weekly Class Times
          </div>
          {/* Class format explanation (Step 10) */}
          <div style={{ fontSize: 13, color: "rgba(255,255,255,0.6)", textAlign: "center", marginBottom: 12, lineHeight: 1.5, fontStyle: "italic" }}>
            All classes are 1 hour: 10-minute warm-up, 40 minutes of boxing, and 10 minutes of core.
          </div>
          <div style={{ background: "#111", border: "1px solid rgba(255,182,18,0.15)", borderRadius: 12, overflow: "hidden" }}>
            {CLASS_SCHEDULE.map((day, i) => (
              <div key={day.day} style={{ display: "flex", alignItems: "flex-start", padding: "9px 14px", borderTop: i > 0 ? "1px solid rgba(255,255,255,0.06)" : "none", gap: 10 }}>
                <div style={{ width: 34, fontSize: 12, fontWeight: 800, color: "#FFB612", flexShrink: 0, paddingTop: 2 }}>{day.day}</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
                  {day.times.map(t => (
                    <span key={t} style={{ background: "rgba(255,182,18,0.1)", color: "rgba(255,255,255,0.8)", fontSize: 11, fontWeight: 700, padding: "3px 7px", borderRadius: 5, whiteSpace: "nowrap" }}>{t}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── PUBLIC LEADERBOARD (Step 13 — below form and schedule) */}
        <LeaderboardSection participantId={null} />

      </div>

      {/* ── CAMPAIGN POPUP — fixed overlay, renders inside outer div ── */}
      {showPopup && (
        <CampaignPopup
          form={form}
          setForm={setForm}
          onSubmit={handleSubmit}
          submitting={submitting}
          error={error}
          onClose={closePopup}
        />
      )}
    </div>
  );
}

const inputStyle = {
  width: "100%", background: "#111", border: "1px solid rgba(255,255,255,0.15)",
  color: "#fff", borderRadius: 10, padding: "13px 16px", fontSize: 15,
  marginBottom: 12, boxSizing: "border-box", outline: "none",
  fontFamily: "inherit",
};

// ── CAMPAIGN POPUP COMPONENT ─────────────────────────────────────────────────
function CampaignPopup({ form, setForm, onSubmit, submitting, error, onClose }) {
  const pInput = {
    width: "100%", background: "#1A1A1A", border: "1px solid rgba(255,182,18,0.3)",
    color: "#fff", borderRadius: 10, padding: "13px 16px", fontSize: 15,
    marginBottom: 12, boxSizing: "border-box", outline: "none", fontFamily: "inherit",
  };
  const ready = !!(form.first_name && form.last_name && form.phone);
  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.88)", zIndex: 9999,
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: "16px", boxSizing: "border-box",
    }}>
      <div style={{
        background: "#0A0A0A", border: "2px solid #FFB612", borderRadius: 16,
        width: "100%", maxWidth: 430, maxHeight: "92vh", overflowY: "auto",
        padding: "28px 20px 24px", position: "relative", boxSizing: "border-box",
      }}>
        {/* X close */}
        <button
          onClick={onClose}
          aria-label="Close"
          style={{
            position: "absolute", top: 10, right: 14, background: "none", border: "none",
            color: "rgba(255,255,255,0.5)", fontSize: 22, cursor: "pointer", padding: "6px 10px",
            lineHeight: 1, zIndex: 1,
          }}
        >✕</button>

        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 14 }}>
          <img src="/nbc_logo.jpg" alt="NBC Boxing" style={{ width: 54, height: 54, objectFit: "contain", borderRadius: 8 }} />
        </div>

        {/* Headline */}
        <h2 style={{ textAlign: "center", fontWeight: 900, color: "#FFB612", lineHeight: 1.15, margin: "0 0 12px", fontSize: "clamp(22px, 6vw, 28px)" }}>
          FREE 1 Week Elite<br />Unlimited Pass
        </h2>

        {/* Copy */}
        <p style={{ fontSize: 14, color: "rgba(255,255,255,0.9)", lineHeight: 1.6, margin: "0 0 8px", textAlign: "center", fontWeight: 600 }}>
          Get unlimited boxing classes for a full week.<br />No commitment, no credit card required.
        </p>
        <p style={{ fontSize: 13, color: "rgba(255,255,255,0.8)", lineHeight: 1.6, margin: "0 0 6px", textAlign: "center" }}>
          Plus, enter to win{" "}
          <strong style={{ color: "#FFB612", fontWeight: 900 }}>3 FREE months</strong>
          {" "}of Unlimited Elite Boxing —{" "}
          <strong style={{ color: "#FFB612", fontWeight: 900 }}>a $240 value</strong>.
        </p>
        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.45)", fontStyle: "italic", textAlign: "center", marginBottom: 18, lineHeight: 1.5 }}>
          After you enter, you&apos;ll get your personal referral link. Share it, get referrals, and climb the leaderboard. Top 3 win free unlimited boxing.
        </div>

        {/* Form */}
        <form onSubmit={onSubmit}>
          <input className="nbc-input" type="text" placeholder="First Name" value={form.first_name}
            onChange={e => setForm(f => ({ ...f, first_name: e.target.value }))} style={pInput} />
          <input className="nbc-input" type="text" placeholder="Last Name" value={form.last_name}
            onChange={e => setForm(f => ({ ...f, last_name: e.target.value }))} style={pInput} />
          <input className="nbc-input" type="tel" placeholder="Phone Number" value={form.phone}
            onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} style={pInput} />

          {error && (
            <div style={{ background: "rgba(255,0,0,0.15)", border: "1px solid rgba(255,0,0,0.4)", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "#ff6b6b", marginBottom: 12 }}>
              {error}
            </div>
          )}

          <button
            type="submit" disabled={submitting}
            style={{
              width: "100%", background: submitting ? "rgba(255,182,18,0.6)" : "#FFB612",
              color: "#000", border: "none", borderRadius: 10, padding: "15px 20px",
              fontSize: 16, fontWeight: 900, cursor: submitting ? "default" : "pointer",
              letterSpacing: 0.3, marginBottom: 10,
            }}
          >
            {submitting ? "Entering…" : "Claim My FREE 1 Week Pass + Enter to Win"}
          </button>

          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", textAlign: "center" }}>
            By entering, you agree to receive SMS updates about your free pass, referral link, and contest status.
          </div>
        </form>
      </div>
    </div>
  );
}
